import { useMemo } from "react"
import { Table, Column, Data, FieldType, Section } from "../../../ui"
import { Address } from "../../types"
import { Data2, useDescribeHooks } from "../../../data-types"
import { TableName } from "../../../../tables"

type Props = {
    rows: Data2[]
    showArchived?: boolean
    readOnly?: boolean
    onCreate?: () => void
    onEditRow?: (addressId: string) => void
    onRemoveRow?: (addressId: string) => void
}

export const AddressesTable = (props: Props) => {
    const { rows, showArchived = false, readOnly, onCreate, onEditRow, onRemoveRow } = props

    const { describe } = useDescribeHooks()

    const addressRows = useMemo(() => rows
        .filter(row => showArchived || !row.archived)
        .map(row => ({
            id: row.id,
            address: describe(TableName.ADDRESSES, row as Address)
        }))
    , [rows, showArchived])

    const columns: Column[] = [
        {
            name: 'address',
            type: FieldType.TEXT,
            label: ''
        }
    ]

    return (
        <Section
            id="addresses"
            space={12}
            collapsable
            defaultExpanded
        >
            <Table
                columns={columns}
                rows={addressRows as Data[]}
                rowId='id'
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onCreate}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
